/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendHealthResponseDto } from '../../models/backend-health-response-dto';

export interface HealthHealthGet$Params {}

export function healthHealthGet(
  http: HttpClient,
  rootUrl: string,
  params?: HealthHealthGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendHealthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, healthHealthGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendHealthResponseDto>;
    }),
  );
}

healthHealthGet.PATH = '/health';
